import { Link } from "react-router-dom";
import { topics } from "@/mocks/news";

export default function SiteFooter() {
  return (
    <footer className="mt-16 bg-background-100 border-t border-background-200">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6 py-10 md:py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-black">
                爆
              </span>
              <span className="text-xl font-black text-foreground-950">爆料网</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 max-w-[280px]">
              一个聚焦社会热点与娱乐动态的资讯爆料平台。我们记录第一手现场，也把官方回应放在同一个页面上。
            </p>
            <p className="mt-3 text-xs text-foreground-400">
              本站所有内容均为演示用模拟数据。
            </p>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-[0.18em] text-foreground-900">栏目导航</h3>
            <div className="mt-4 flex flex-col gap-2.5 text-sm">
              <Link to="/" className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer">
                首页
              </Link>
              <Link
                to="/category/society"
                className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                社会爆料
              </Link>
              <Link
                to="/category/entertainment"
                className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                娱乐爆料
              </Link>
              <Link
                to="/search"
                className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                搜索爆料
              </Link>
              <Link
                to="/about"
                className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer"
              >
                关于我们
              </Link>
            </div>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-[0.18em] text-foreground-900">热门专题</h3>
            <div className="mt-4 flex flex-col gap-2.5 text-sm">
              {topics.slice(0, 5).map((topic) => (
                <Link
                  key={topic.id}
                  to={`/topic/${topic.id}`}
                  className="text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer truncate"
                >
                  {topic.name}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-label text-sm tracking-[0.18em] text-foreground-900">联系与爆料</h3>
            <div className="mt-4 space-y-3 text-sm text-foreground-600">
              <p className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500" />
                tip@baoliao.example
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-wechat-line text-primary-500" />
                微信：baoliao_news
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line text-primary-500" />
                线索受理：09:00 - 23:00
              </p>
            </div>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-1.5 h-9 px-4 rounded-md border border-primary-300 text-primary-700 text-sm hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-send-plane-line" />
              提交反馈
            </Link>
          </div>
        </div>

        <div className="mt-9 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 text-xs text-foreground-500">
          <p>© 2026 爆料网 BAOLIAO. 演示站点，内容与真实事件无关。</p>
          <p className="flex items-center gap-3">
            <span>理性围观 · 不信谣不传谣</span>
            <span className="hidden sm:inline h-3 w-px bg-background-300" />
            <Link to="/about" className="hover:text-primary-600 transition-colors cursor-pointer">
              版权与免责声明
            </Link>
          </p>
        </div>
      </div>
    </footer>
  );
}